import React from 'react';
import PropTypes from 'prop-types';
import Banner from '../Banner';

export const NIVA_HEADER = 'Make a plan to vote!';

const NIVABanner = (props) => {
    const trackingData = {
        type: 'TRACK_NIVA_BANNER_CLICK',
        meta: {
            analytics: {
                action: 'NivaBannerClick',
                category: props.category,
            },
        },
    };

    return (
        <Banner leftAccentColor="#F05537" style="dark" header={NIVA_HEADER}>
            <span>
                <a
                    onClick={() => {
                        props.handleTracking(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`http://www.headcount.org/EBmyvc`}
                >
                    Check your voter status, voting options, and polling place
                </a>{' '}
                to make your voice heard this election.
            </span>
        </Banner>
    );
};

NIVABanner.propTypes = {
    handleTracking: PropTypes.func,
    trackingParams: PropTypes.string,
    category: PropTypes.string,
};

export default NIVABanner;
